import Component from './Widget.vue';

export default {
  install(Vue) {
    Vue.component('BkfWidget', Component);
  },
};
